export enum LeaveType {
    SERIOUS_HEALTH_CONDITION = 'Serious health condition',
    MATERNITY_LEAVE = 'Maternity leave',
    BONDING_WITH_A_CHILD = 'Bonding with a child',
    NICU_CARE = 'NICU care',
    ACTIVE_DUTY_OR_MILITARY_EVENTS = 'Active duty or military events',
    PERSONAL_OR_FAMILY_VIOLENCE = 'Personal / family violence',
}